export enum ParkPermitType {
  EXTENDED = "EXTENDED",
  LIMITED = "LIMITED",
  UNLIMITED = "UNLIMITED"
}